/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Minimum severity level for notification escalation
 * @export
 */
export const ControlNotificationEscalationSeverity = {
    Informational: 'INFORMATIONAL',
    Low: 'LOW',
    Medium: 'MEDIUM',
    High: 'HIGH',
    Critical: 'CRITICAL'
} as const;
export type ControlNotificationEscalationSeverity = typeof ControlNotificationEscalationSeverity[keyof typeof ControlNotificationEscalationSeverity];


export function ControlNotificationEscalationSeverityFromJSON(json: any): ControlNotificationEscalationSeverity {
    return ControlNotificationEscalationSeverityFromJSONTyped(json, false);
}

export function ControlNotificationEscalationSeverityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlNotificationEscalationSeverity {
    return json as ControlNotificationEscalationSeverity;
}

export function ControlNotificationEscalationSeverityToJSON(value?: ControlNotificationEscalationSeverity | null): any {
    return value as any;
}

